<template>
  <div>
    <div class="card mx-auto" style="border:none">
      <img
        src="../assets/user.png"
        class="card-img-top img-fluid mx-auto mt-3 mb-3"
        alt="userImg"
      />
      <div class="card-body">
        <h2 class="card-title">Inicio de Sesión</h2>
        <Login></Login>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Login from "@/components/Login/LoginFormComponent.vue";

export default {
  name: "HomeView",
  components: {
    Login,
  },
};
</script>
<style scoped>
.card-img-top {
  max-width: 180px;
  max-height: 180px;
}
@media screen and (max-width: 500px) {
  .card-img-top {
  max-width: 120px;
  max-height: 120px;
}
}
</style>
